export default {
  primary: "#FF5C00",
  secondary: "#FFF327",
  lighter: "#FFFFFF",
}
